export default [
  {
    label: "Nano 1k - 10k",
    min: 1000,
    max: 10000,
  },
  {
    label: "Micro 10k - 50k",
    min: 10001,
    max: 50000,
  },
  {
    label: "Mid-Tier 50k - 500k",
    min: 50001,
    max: 500000,
  },
  {
    label: "Macro 500k - 1M",
    min: 500001,
    max: 1000000,
  },
  {
    label: "Mega 1M+",
    min: 1000001,
    max: null,
  },
];
